'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    fileItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: theme.textColor,
      marginBottom: 12,
      paddingBottom: 4,
      borderBottom: '1px dotted ' + theme.upload.borderItemColor,
      transition: theme.transition(['all']),
      '&:last-child': {
        marginBottom: 0,
        borderBottom: 0,
        paddingBottom: 0
      },
      '&.hide': {
        opacity: 0
      }
    },
    fileItemChip: {
      maxWidth: 333,
      display: 'flex',
      border: '1px solid ' + theme.upload.borderColor,
      color: theme.upload.color,
      height: 48,
      padding: '4px 12px 4px 12px',
      borderRadius: 3,
      boxSizing: 'border-box',
      alignItems: 'center',
      position: 'relative',
      marginRight: 8,
      marginBottom: 8,
      "float": 'left',
      '&.error $chipHelperText': {
        color: theme.upload.errorColor
      },
      '&.error': {
        borderColor: theme.upload.errorColor
      }
    },
    chipTextBox: {
      padding: '0 24px 0 12px',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column'
    },
    chipText: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    chipHelperText: {},
    chipImg: {
      maxHeight: 32,
      maxWidth: 32,
      borderRadius: 4
    },
    fileItemInfo: {
      flexGrow: 1,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      wordBreak: 'break-all',
      whiteSpace: 'nowrap'
    },
    fileItemControls: {
      marginLeft: 8,
      display: 'flex',
      flexBasis: '16px',
      flex: '0 1 auto'
    },
    delFileIcon: {
      cursor: 'pointer',
      '&:hover': {
        '& .fill': {
          fill: theme.upload.iconCloseHoverFill
        }
      }
    },
    delFileBtn: {
      cursor: 'pointer',
      padding: 4
    },
    fileImg: {
      maxHeight: 200,
      marginTop: 8
    }
  };
};